import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowshoeNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.76 7.86l1.13 17.81a5.567 5.567 0 002.94 4.58l3.15 1.69 3.14-1.68a5.545 5.545 0 002.94-4.58L15.2 7.87A7.252 7.252 0 007.98.17 7.236 7.236 0 00.76 7.86zm1.71.968h1.639l1.06 5.233v1.109h-2.3l-.4-6.342zm10.1 14.347h-2.535v1.65h2.435l-.05.755a3.926 3.926 0 01-2.07 3.22l-1.525.813V26.9h-1.65v2.729L5.61 28.8a3.913 3.913 0 01-2.07-3.23l-.05-.745H6v-1.65H3.39l-.41-6.345h2.19V20a2.83 2.83 0 105.66 0v-3.17h2.15l-.41 6.345zM6.83 20v-7a1.17 1.17 0 112.34 0v7a1.17 1.17 0 11-2.34 0zm6.25-4.83h-2.25v-1.016h.014L11.9 8.825h1.58l-.4 6.345zM8.826 1.9a5.634 5.634 0 013.224 1.69 5.512 5.512 0 011.5 3.584h-1.712a3.905 3.905 0 00-3.012-2.91V1.9zM9.7 6.562a2.312 2.312 0 01.63 1.7l-.51 2.578A2.793 2.793 0 008 10.17a2.863 2.863 0 00-1.8.653l-.532-2.571a2.308 2.308 0 01.632-1.69 2.388 2.388 0 013.4 0zM7.174 1.89v2.373A3.9 3.9 0 004.16 7.174H2.4A5.542 5.542 0 013.9 3.59a5.473 5.473 0 013.274-1.7zM24.01.17a7.236 7.236 0 00-7.22 7.69l1.13 17.81a5.567 5.567 0 002.94 4.58l3.15 1.69 3.14-1.68a5.545 5.545 0 002.94-4.58l1.14-17.81a7.25 7.25 0 00-7.22-7.7zm1.72 6.392a2.3 2.3 0 01.63 1.7l-.512 2.59a2.762 2.762 0 00-1.818-.678 2.863 2.863 0 00-1.8.653l-.53-2.575a2.308 2.308 0 01.629-1.69 2.387 2.387 0 013.4 0zM25.2 13v7a1.175 1.175 0 11-2.35 0v-7a1.175 1.175 0 112.35 0zm-5.27-9.41a5.47 5.47 0 013.27-1.7v2.373a4 4 0 00-2.08 1.17 3.955 3.955 0 00-.931 1.741h-1.76a5.542 5.542 0 011.5-3.584zM18.5 8.828h1.639l1.06 5.236v1.106h-2.3l-.4-6.342zm10.1 14.347h-2.536v1.65H28.5l-.05.755a3.925 3.925 0 01-2.07 3.22l-1.525.807V26.9h-1.65v2.728L21.64 28.8a3.934 3.934 0 01-2.07-3.23l-.05-.745h2.51v-1.65h-2.61l-.41-6.345h2.19V20a2.825 2.825 0 005.65 0v-3.17h2.16l-.41 6.345zm.51-8.005h-2.26v-1.018l.024.005 1.057-5.332h1.579l-.4 6.345zm-1.243-8a3.9 3.9 0 00-3.012-2.91V1.9a5.428 5.428 0 013.225 1.69 5.511 5.511 0 011.5 3.584l-1.713-.004z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowshoeNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowshoeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowshoeNormalMedium;
